(() => {
  "use strict";

  const SUPABASE_URL = "https://hawhqhhgbiajblaulusp.supabase.co";
  const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhhd2hxaGhnYmlhamJsYXVsdXNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUxNjE0NTIsImV4cCI6MjEwMDczNzQ1Mn0.JjMUcG7zfXhPVlJHSe7KgpoV3Orz1A8uaZ8rAZBYojs";
  // Elements
  const root = document.getElementById("lh-exit-survey");
  if (!root) return;
  const TESTING_MODE = new URLSearchParams(window.location.search).get("lh_survey_test") === "1"
    || root.dataset.designMode === "true";

  const form = document.getElementById("lh-survey-form");
  const steps = {
    1: document.getElementById("lh-survey-step-1"),
    2: document.getElementById("lh-survey-step-2"),
    3: document.getElementById("lh-survey-step-3")
  };
  const successStep = root.querySelector("[data-survey-success]");
  const q2Title = document.getElementById("lh-survey-q2-title");
  const q2Options = document.getElementById("lh-survey-q2-options");
  const q1NextButton = document.getElementById("lh-survey-q1-next");
  const submitButton = form.querySelector('button[type="submit"]');

  // Session Duration logic
  let sessionStartVal = Date.now();
  try {
    const storedStart = sessionStorage.getItem("lh_session_start");
    if (storedStart) {
      sessionStartVal = Number(storedStart);
    } else {
      sessionStorage.setItem("lh_session_start", String(sessionStartVal));
    }
  } catch (e) {}

  const sessionStarted = sessionStartVal;
  const pageStarted = Date.now();
  
  let surveyOpened = false;
  let currentStep = 1;
  let surveyConfig = null;

  // Selected State
  let selectedQ1Option = null; // { id, option_text }
  let selectedQ2Answer = "";

  const isMobile = window.innerWidth <= 900
    || window.matchMedia("(pointer: coarse)").matches;

  // Attribution Init
  function initAttribution() {
    try {
      const params = new URLSearchParams(window.location.search);
      const utmSource = params.get("utm_source");
      const utmMedium = params.get("utm_medium");
      const utmCampaign = params.get("utm_campaign");

      if (utmSource) {
        sessionStorage.setItem("lh_utm_source", utmSource);
        if (utmMedium) sessionStorage.setItem("lh_utm_medium", utmMedium);
        if (utmCampaign) sessionStorage.setItem("lh_utm_campaign", utmCampaign);
      }

      // Referrer tracking
      const referrer = document.referrer;
      if (referrer && !sessionStorage.getItem("lh_traffic_source")) {
        const referrerHost = new URL(referrer).hostname;
        if (referrerHost !== window.location.hostname) {
          sessionStorage.setItem("lh_traffic_source", referrerHost);
        }
      }
    } catch (e) {}
  }

  function getTrafficData() {
    let utmSource = null;
    let utmCampaign = null;
    let trafficSource = "direct";

    try {
      const params = new URLSearchParams(window.location.search);
      utmSource = params.get("utm_source") || sessionStorage.getItem("lh_utm_source");
      utmCampaign = params.get("utm_campaign") || sessionStorage.getItem("lh_utm_campaign");
      
      const storedSource = sessionStorage.getItem("lh_traffic_source");
      if (utmSource) {
        trafficSource = utmSource;
      } else if (storedSource) {
        trafficSource = storedSource;
      }
    } catch (e) {}

    return {
      traffic_source: trafficSource,
      utm_source: utmSource,
      utm_campaign: utmCampaign
    };
  }

  function getContext() {
    return {
      page_type: root.dataset.pageType || null,
      page_url: window.location.href,
      product_name: root.dataset.productTitle || null,
      product_category: root.dataset.productType || null
    };
  }

  function showStep(number) {
    currentStep = number;
    Object.values(steps).forEach((step) => {
      if (step) step.hidden = true;
    });
    if (successStep) successStep.hidden = true;
    if (steps[number]) steps[number].hidden = false;
  }

  function shownThisSession() {
    try {
      return sessionStorage.getItem("lh_exit_survey_session") === "1";
    } catch {
      return surveyOpened;
    }
  }

  function seenRecently(frequencyDays) {
    try {
      const lastShown = localStorage.getItem("lh_exit_survey_last_shown");
      if (!lastShown) return false;
      const difference = Date.now() - Number(lastShown);
      return difference < frequencyDays * 24 * 60 * 60 * 1000;
    } catch {
      return false;
    }
  }

  function excludeConverted(shouldExclude) {
    if (!shouldExclude) return false;
    try {
      if (localStorage.getItem("lh_customer_converted") === "1") return true;
      const currentPath = window.location.pathname.toLowerCase();
      if (currentPath.includes("/thank_you") || currentPath.includes("/thank-you") || currentPath.includes("/orders/")) {
        localStorage.setItem("lh_customer_converted", "1");
        return true;
      }
    } catch (e) {}
    return false;
  }

  function eligible(settings) {
    if (surveyOpened) return false;
    if (!root.hidden) return false;

    if (!TESTING_MODE) {
      if (shownThisSession()) return false;
      try {
        if (localStorage.getItem("lh_exit_survey_completed")) return false;
      } catch (e) {}
      if (seenRecently(settings.frequency_cap_days)) return false;
      if (excludeConverted(settings.exclude_converted)) return false;
    }

    return true;
  }

  function populateDOM(config) {
    try {
      const settings = config.survey_settings;
      if (!settings) return;

      // Update Title & Subtitle safely
      const titleElem = document.getElementById("lh-survey-title");
      if (titleElem) titleElem.textContent = settings.survey_title;

      const subtitleElem = document.getElementById("lh-survey-subtitle");
      if (subtitleElem) subtitleElem.textContent = settings.survey_subtitle || "Takes less than 10 seconds.";

      // Update Q1 Title & Options
      const q1 = config.survey_questions.find(q => q.question_type === "primary");
      if (q1) {
        const q1Title = document.getElementById("lh-survey-q1-title");
        if (q1Title) q1Title.textContent = q1.question_text;

        const optionsWrapper = document.getElementById("lh-survey-q1-options");
        if (optionsWrapper) {
          optionsWrapper.replaceChildren();
          
          // Sort Q1 options by display order
          const sortedOptions = (q1.survey_options || [])
            .filter(o => o.is_enabled)
            .sort((a, b) => a.display_order - b.display_order);

          sortedOptions.forEach(opt => {
            const label = document.createElement("label");
            label.className = "lh-survey__option";

            const input = document.createElement("input");
            input.type = "radio";
            input.name = "question_1";
            input.value = opt.option_text;
            input.dataset.optionId = opt.id;
            input.required = true;

            const span = document.createElement("span");
            span.textContent = opt.option_text;

            label.append(input, span);
            optionsWrapper.append(label);
          });

        }
      }

      // Update Q3 Title (Comment label)
      const q3 = config.survey_questions.find(q => q.question_type === "textarea");
      if (q3) {
        const q3Title = document.getElementById("lh-survey-q3-title");
        if (q3Title) {
          q3Title.textContent = q3.question_text;
          if (q3.is_required) {
            const reqMarker = document.createElement("span");
            reqMarker.textContent = " *";
            reqMarker.style.color = "var(--lh-gold)";
            q3Title.appendChild(reqMarker);
          }
        }
        const commentArea = document.getElementById("lh-survey-comment");
        if (commentArea) {
          commentArea.required = q3.is_required;
        }
      }

      // Update Success message
      const successMsg = document.getElementById("lh-survey-success-message");
      if (successMsg) successMsg.textContent = settings.success_message || "Your feedback helps us improve your shopping experience.";
    } catch (err) {
      console.error("[LH Survey] DOM Population failed", err);
    }
  }

  function renderQuestion2() {
    try {
      const checkedOption = root.querySelector('input[name="question_1"]:checked');
      if (checkedOption) {
        selectedQ1Option = {
          id: checkedOption.dataset.optionId,
          option_text: checkedOption.value
        };
      }
      if (!selectedQ1Option || !surveyConfig) return;

      const triggerOptionId = selectedQ1Option.id;
      const conditionalQuestions = Array.isArray(surveyConfig.conditional_questions)
        ? surveyConfig.conditional_questions
        : [];
      const mapping = conditionalQuestions.find(c => String(c.trigger_option_id) === String(triggerOptionId));

      if (!mapping) {
        showStep(3);
        return;
      }

      const q2 = surveyConfig.survey_questions.find(q => q.id === mapping.dependent_question_id);
      if (!q2) {
        showStep(3);
        return;
      }

      q2Title.textContent = q2.question_text;
      q2Options.replaceChildren();

      // Q2 Text Input Element
      const input = document.createElement("input");
      input.type = "text";
      input.id = "lh-survey-q2-input";
      input.className = "lh-survey__input-text";
      input.placeholder = "Please specify...";
      input.required = q2.is_required;
      if (selectedQ2Answer) {
        input.value = selectedQ2Answer;
      }

      // Next Button
      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "lh-survey__submit";
      nextBtn.style.marginTop = "12px";
      nextBtn.textContent = "Next";

      // Listen for click to transition to Step 3
      nextBtn.addEventListener("click", () => {
        if (input.required && !input.value.trim()) {
          input.reportValidity();
          return;
        }
        selectedQ2Answer = input.value.trim();
        showStep(3);
      });

      // Also support Enter key inside the input
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          nextBtn.click();
        }
      });

      q2Options.append(input, nextBtn);
      showStep(2);
      
      setTimeout(() => {
        input.focus();
      }, 50);
    } catch (err) {
      console.error("[LH Survey] Question 2 rendering failed", err);
      showStep(3);
    }
  }

  function handleFirstStepNext() {
    const checkedOption = root.querySelector('input[name="question_1"]:checked');
    if (!checkedOption) {
      const firstInput = root.querySelector('input[name="question_1"]');
      if (firstInput) firstInput.reportValidity();
      return;
    }

    selectedQ1Option = {
      id: checkedOption.dataset.optionId,
      option_text: checkedOption.value
    };
    renderQuestion2();
  }

  function openSurvey(bypass = false) {
    try {
      if (!surveyConfig) return;
      if (!bypass && !eligible(surveyConfig.survey_settings)) return;

      surveyOpened = true;
      
      // Mark session and last shown
      if (!TESTING_MODE) {
        try {
          sessionStorage.setItem("lh_exit_survey_session", "1");
          localStorage.setItem("lh_exit_survey_last_shown", String(Date.now()));
        } catch (e) {}
      }

      root.hidden = false;
      showStep(1);
      document.body.style.overflow = "hidden";

      const firstInput = root.querySelector('input[name="question_1"]');
      setTimeout(() => {
        firstInput?.focus();
      }, 50);
    } catch (e) {
      console.error("[LH Survey] Open failed", e);
    }
  }

  function closeSurvey() {
    try {
      root.hidden = true;
      surveyOpened = false;
      document.body.style.overflow = "";
      if (!TESTING_MODE) {
        localStorage.setItem("lh_exit_survey_last_shown", String(Date.now()));
      }
    } catch (e) {}
  }

  function buildPayload() {
    const traffic = getTrafficData();
    const context = getContext();

    // Map page_type safely to match DB constraints
    let pageType = context.page_type ? context.page_type.toLowerCase() : null;
    if (pageType === "index") {
      pageType = "home";
    } else if (!["home", "collection", "product", "cart", "checkout"].includes(pageType)) {
      pageType = null;
    }

    const device = isMobile ? "mobile" : "desktop";

    // Locate Q2 references
    let q2QuestionId = null;
    let q2Answer = null;
    if (selectedQ1Option && surveyConfig) {
      const conditionalQuestions = Array.isArray(surveyConfig.conditional_questions)
        ? surveyConfig.conditional_questions
        : [];
      const mapping = conditionalQuestions.find(
        c => String(c.trigger_option_id) === String(selectedQ1Option.id)
      );
      if (mapping) {
        q2QuestionId = mapping.dependent_question_id;
        q2Answer = selectedQ2Answer || null;
      }
    }

    return {
      survey_id: surveyConfig.id,
      q1_option_id: selectedQ1Option ? selectedQ1Option.id : null,
      q1_text: selectedQ1Option ? selectedQ1Option.option_text : null,
      q2_question_id: q2QuestionId,
      q2_answer: q2Answer,
      comment: document.getElementById("lh-survey-comment")?.value.trim().slice(0, 500) || null,
      device: device,
      page_type: pageType,
      product: context.product_name || null,
      product_category: context.product_category || null,
      page_url: window.location.href,
      traffic_source: traffic.traffic_source,
      utm_source: traffic.utm_source,
      utm_campaign: traffic.utm_campaign,
      session_duration: Math.round((Date.now() - sessionStarted) / 1000),
      time_on_page: Math.round((Date.now() - pageStarted) / 1000)
    };
  }

  async function submitResponse(payload) {
    const endpoint = `${SUPABASE_URL}/rest/v1/survey_responses`;
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errText = await response.text();
      console.error("[LH Survey] DB Error detail:", errText);
      throw new Error(`Survey submission failed: ${response.status} - ${errText}`);
    }
  }

  // Fetch active survey configuration
  async function fetchSurveyConfig() {
    const endpoint = `${SUPABASE_URL}/rest/v1/surveys?is_active=eq.true&select=id,survey_settings(*),survey_questions(*,survey_options(*)),conditional_questions(*)`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`
      }
    });

    if (!response.ok) {
      throw new Error(`Fetch config failed: ${response.status}`);
    }

    const data = await response.json();
    if (!data || data.length === 0) return null;
    return data[0];
  }

  // Event Listeners setup
  function bindTriggers(settings) {
    try {
      const delaySeconds = Math.max(0, Number(settings.min_session_duration || 59));
      window.setTimeout(openSurvey, delaySeconds * 1000);
    } catch (e) {
      console.error("[LH Survey] Trigger binding failed", e);
    }
  }

  // Form Submission
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (currentStep !== 3) return;
    if (!selectedQ1Option) return;

    submitButton.disabled = true;
    submitButton.textContent = "Submitting...";

    try {
      await submitResponse(buildPayload());
      
      if (!TESTING_MODE) {
        try {
          localStorage.setItem("lh_exit_survey_completed", "1");
        } catch (e) {}
      }

      showStep(999); // Hide all input steps
      successStep.hidden = false;

      setTimeout(() => {
        closeSurvey();
      }, 2200);
    } catch (error) {
      console.error("[LH Survey] Submission failed", error);
      submitButton.disabled = false;
      submitButton.textContent = "Submit feedback";
    }
  });

  // Option Changes & Navigation
  root.addEventListener("change", (event) => {
    try {
      const target = event.target;
      if (target.matches('input[name="question_1"]')) {
        selectedQ1Option = {
          id: target.dataset.optionId,
          option_text: target.value
        };
        selectedQ2Answer = "";
      }
    } catch (e) {
      console.error(e);
    }
  });

  root.addEventListener("click", (event) => {
    try {
      if (event.target.closest("[data-survey-close]")) {
        closeSurvey();
        return;
      }
      if (event.target.closest("[data-survey-back]")) {
        selectedQ2Answer = "";
        showStep(1);
        return;
      }
    } catch (e) {
      console.error(e);
    }
  });

  if (q1NextButton) {
    q1NextButton.addEventListener("click", handleFirstStepNext);
  }

  // Initialization
  async function init() {
    try {
      initAttribution();
      
      surveyConfig = await fetchSurveyConfig();
      if (!surveyConfig) return;

      const settings = surveyConfig.survey_settings;
      if (!settings || !settings.is_enabled) return;

      // Check current page exclusion
      const currentPath = window.location.pathname.toLowerCase();
      const isExcluded = (settings.excluded_urls || []).some(url => {
        const cleanUrl = url.trim().toLowerCase();
        return cleanUrl && currentPath.includes(cleanUrl);
      });
      if (isExcluded) return;

      // Check conversion exclusion
      if (excludeConverted(settings.exclude_converted)) return;

      // Populate DOM elements with the actual survey questions/titles
      populateDOM(surveyConfig);

      // Bind trigger listeners
      bindTriggers(settings);
    } catch (error) {
      // Progressive enhancement: fail silently
      console.warn("[LH Survey] Initialisation failed silently", error);
    }
  }

  // Define manual API interfaces for debugging and testing
  window.LHSurvey = {
    version: "2026-07-27.3",
    next: handleFirstStepNext,
    open: () => {
      if (surveyConfig) {
        populateDOM(surveyConfig);
        surveyOpened = false;
        openSurvey(true);
      } else {
        fetchSurveyConfig().then(config => {
          if (config) {
            surveyConfig = config;
            populateDOM(config);
            surveyOpened = false;
            openSurvey(true);
          } else {
            console.error("[LH Survey] No active survey found.");
          }
        }).catch(err => {
          console.error("[LH Survey] Manual open failed to load active configuration", err);
        });
      }
    },
    close: closeSurvey,
    debug: () => {
      console.log({
        sessionStarted: new Date(sessionStarted).toLocaleTimeString(),
        pageStarted: new Date(pageStarted).toLocaleTimeString(),
        isMobile: isMobile,
        testingMode: TESTING_MODE,
        surveyOpened: surveyOpened,
        shownThisSession: shownThisSession(),
        seenRecently: surveyConfig ? seenRecently(surveyConfig.survey_settings.frequency_cap_days) : null,
        excludeConverted: surveyConfig ? excludeConverted(surveyConfig.survey_settings.exclude_converted) : null,
        surveyConfig: surveyConfig
      });
    }
  };

  // Run init
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
